/*
 **	Stacked Chevrons Component for Pressure Trends
 **	OMNI_IQ Mobile (c) 2025 Silver Falls Capital. All Rights Reserved
 */

import React from 'react'
import { MaterialIcon } from './MaterialIcon'

interface StackedChevronsProps {
  direction: 'up' | 'down'
  count: 1 | 2 | 3
  color: string
  size?: number
}

export const StackedChevrons: React.FC<StackedChevronsProps> = ({
  direction,
  count,
  color,
  size = 16
}) => {
  const iconName = direction === 'up' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'

  // Calculate spacing between chevrons - balanced overlap for visibility
  const spacing = -(size * 0.25) // 25% overlap for balanced spacing

  // Calculate total height needed for stacked chevrons
  const totalHeight = size + (Math.abs(spacing) * (count - 1))

  return (
    <div style={{
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: `${totalHeight}px`, // Dynamic height based on count
      position: 'relative',
      width: `${size}px`,
      justifyContent: 'center'
    }}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            top: direction === 'up'
              ? `${index * spacing}px`
              : `${(count - 1 - index) * spacing}px`,
            opacity: 1 - (index * 0.2) // Slightly stronger fade for better distinction
          }}
        >
          <MaterialIcon
            name={iconName}
            size={size}
            color={color}
          />
        </div>
      ))}
    </div>
  )
}